<template>
  <div>
    <quick-selector
      :label="quickSelectorLabel"
      :id="quickSelectorId"
    >
      <div class="row">
        <div v-for="filter in filters" class="col-md-3">
          <div class="form-group">
            <label :for="filter.id">{{ filter.label }}</label>
            <select-field
              :id="filter.id"
              :name="filter.id"
              :items="filter.items"
              :empty-option="true"
              @selected="onFilterSelected"
              :ref="'filter-'+filter.id"
            >
            </select-field>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <a class="btn btn-tertiary" @click.prevent="reset">
              {{ resetLabel }}
            </a>
          </div>
        </div>
      </div>
    </quick-selector>
    <visibility-matrix-table
      :fields-visibility="filteredVisibility"
      :fields-visibility-properties="fieldsVisibilityProperties"
      :select-all-label="selectAllLabel"
      :hidden-fields="hiddenFields"
      :hidden-field-label="hiddenFieldLabel"
      :hidden-fields-label="hiddenFieldsLabel"
      @select="onSelect"
      @selectAll="onSelectAll"
    />
  </div>
</template>

<script>
import { SelectField } from 'vue-bootstrap';
import QuickSelector from './QuickSelector';
import VisibilityMatrixTable from './VisibilityMatrixTable';

export default {
  components: {
    SelectField,
    QuickSelector,
    VisibilityMatrixTable
  },
  data() {
    const selectedFilters = {};
    this.filters.forEach(filter => selectedFilters[filter.id] = null);

    return {
      visibility: JSON.parse(JSON.stringify(this.fieldsVisibility)),
      selectedFilters: selectedFilters
    };
  },
  props: {
    fieldsVisibility: {
      type: Array,
      required: true
    },
    fieldsVisibilityProperties: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      default: () => []
    },
    quickSelectorId: {
      type: String,
      required: true
    },
    quickSelectorLabel: {
      type: String,
      default: 'Filters'
    },
    resetLabel: {
      type: String,
      default: 'Reset'
    },
    selectAllLabel: {
      type: String,
      default: 'Select all'
    },
    hiddenFieldLabel: {
      type: String,
      default: 'hidden field'
    },
    hiddenFieldsLabel: {
      type: String,
      default: 'hidden fields'
    }
  },
  computed: {
    hiddenFields() {
      return this.visibility.length - this.filteredVisibility.length;
    },
    filteredVisibility() {
      return this.visibility.filter(field => {
        for (let key in this.selectedFilters) {
          // Skip to the next filter
          if (!this.selectedFilters[key]) {
            continue;
          }

          if (Array.isArray(field[key])) {
            // Array
            if (
              !field[key].includes('all') &&
              !field[key].includes(this.selectedFilters[key])
            ) {
              return false;
            }
          } else {
            // Primitive
            if (
              field[key] === undefined ||
              field[key] != this.selectedFilters[key]
            ) {
              return false;
            }
          }
        }

        return true;
      });
    }
  },
  methods: {
    onSelect(field, property, checked) {
      const index = this.visibility.findIndex(f => f.id === field);

      if (index >= 0) {
        this.$set(this.visibility, index, {
          ...this.visibility[index],
          [property]: checked
        });
      }
    },
    onSelectAll(property, checked) {
      this.visibility = this.visibility.map(field => {
        if (this.filteredVisibility.find(f => f.id === field.id)) {
          return { ...field, [property]: checked };
        }
        return field;
      });
    },
    onFilterSelected(name, value) {
      this.selectedFilters = { ...this.selectedFilters, [name]: value };
    },
    reset() {
      Object.keys(this.selectedFilters).forEach(id => {
        this.$set(this.selectedFilters, id, null);
        this.$refs['filter-'+id][0].reset();
      });
    }
  }
};
</script>
